export const DEFAULT_GROUPS_DESCRIPTION = {
    FLEET_ADMIN: {
        key: 'Fleet_Admin',
        titleId: 'intl-msg:groups.name.Fleetadmin',
        generalDescription: 'intl-msg:groups.names.description.Fleetadmin',
    },
    FLEET_USERS: {
        key: 'Fleet_Users',
        titleId: 'intl-msg:groups.name.Fleetusers',
        generalDescription: 'intl-msg:groups.names.description.Fleetusers',
    },
    FLEET_DRIVER: {
        key: 'Fleet_Driver',
        titleId: 'intl-msg:groups.name.Fleetdriver',
        generalDescription: 'intl-msg:groups.names.description.Fleetdriver',
    },
    BOOKING_EXPERT: {
        key: 'Booking_Expert',
        titleId: 'intl-msg:groups.name.Bookingexpert',
        generalDescription: 'intl-msg:groups.name.description.Bookingexpert',
    },
    ANALYSIS_EXPERT: {
        key: 'Analysis_Expert',
        titleId: 'intl-msg:groups.name.Analysisexpert',
        generalDescription: 'intl-msg:groups.name.description.Analysisexpert',
    },
    CUSTOM: {
        key: 'Custom',
        titleId: 'intl-msg:groups.name.Custom',
        generalDescription: 'intl-msg:groups.names.description.Custom',
    },
};

export const DEFAULT_SUPPLIER_GROUPS_DESCRIPTION = {
    SUPPLIER_ADMIN: {
        key: 'Supplier_Admin',
        titleId: 'intl-msg:groups.name.Supplieradmin',
        generalDescription: 'intl-msg:groups.names.description.Supplieradmin',
    },
    SUPPLIER_USER: {
        key: 'Supplier_User',
        titleId: 'intl-msg:groups.name.Supplieruser',
        generalDescription: 'intl-msg:groups.names.description.Supplieruser',
    },
};

export const DEFAULT_BUYER_GROUPS_DESCRIPTION = {
    BUYER_ADMIN: {
        key: 'Buyer_Admin',
        titleId: 'intl-msg:groups.name.Buyeradmin',
        generalDescription: 'intl-msg:groups.names.description.Buyeradmin',
    },
    BUYER_USER: {
        key: 'Buyer_User',
        titleId: 'intl-msg:groups.name.Buyeruser',
        generalDescription: 'intl-msg:groups.names.description.Buyeruser',
    },
};
